export default __webpack_public_path__ + "static/media/about4.f1fdd9c0.png";